// src/pages/RecipeJournals/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./CollectionPage";
import { getRecipeJournals, PRODUCTS_PER_PAGE } from "../data/recipeJournals";

export default function RecipeJournals() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getRecipeJournals()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/recipe-journals",
    announcement: {
      headline: "Preserve your favourite recipes — beautifully.",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Recipe Journals",
      subtitle: "Every recipe, beautifully kept",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "I gifted this to my mum and she cried — it's the most beautiful way to keep family recipes.",
      quoteLink: "#",
      rating: "4.8",
      ratingCount: "500+",
    },
  };

  return <CollectionPage config={config} />;
}